import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "EmailFilled"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1428_20531)"><rect width="16" height="16" fill="#F2F3F7"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99956 8.6256L1.47961 3.0228C1.51469 3.01491 1.54625 3 1.5822 3H14.4178C14.4397 3 14.4862 3.01578 14.5213 3.02192L7.99956 8.6256ZM15 3.7979V12.2205C15 12.2731 14.9842 12.3187 14.9719 12.3669L10.3424 7.59185L14.9649 3.61903C14.9833 3.67602 15 3.73477 15 3.7979ZM1.0342 3.61815L5.65848 7.59185L1.02893 12.3669C1.01754 12.3196 1 12.2731 1 12.2205V3.7979C1 3.73389 1.01754 3.67602 1.03507 3.61815H1.0342ZM9.89171 8.12407L14.5598 12.9377C14.5134 12.95 14.4678 12.9676 14.4169 12.9676H1.5822C1.5331 12.9676 1.48751 12.95 1.44191 12.9377L6.10916 8.12407L7.8128 9.58834C7.91966 9.68208 8.07946 9.68208 8.18632 9.58834L9.89171 8.12407V8.12407Z" fill="#5587FF"></path></g><defs><clipPath id="clip0_1428_20531"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var EmailFilled = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { EmailFilled as default };
